var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./breadcrumbs.js"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-da1d2216\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./breadcrumbs.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/breadcrumbs/breadcrumbs.vue
// module id = 10
// module chunks = 0